import { render, staticRenderFns } from "./UserBankAccounts.vue?vue&type=template&id=11f0b0c0&scoped=true&"
import script from "./UserBankAccounts.vue?vue&type=script&lang=js&"
export * from "./UserBankAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f0b0c0",
  null
  
)

export default component.exports